import { Icon } from '@ps/web-fusion-components';
import { Language, Poker } from '@ps/web-fusion-icons';
import type {
  MainNavigationBlock,
  SecondaryNavigationBlock,
  SupportNavigationBlock
} from '@ps/web-martech-cms-types/SiteHeader';
import { useResolver } from '@ps/web-shared-components';

import StarsNavigationItem from '@swf/components/StarsNavigation/StarsNavigationItem';
import ChallengesIcon from '@swf/core/assets/challenges.svg';
import BrandMerchIcon from '@swf/core/assets/sideMenu/brand-merch.svg';
import PromotionsIcon from '@swf/core/assets/sideMenu/promotions.svg';
import StarIcon from '@swf/core/assets/sideMenu/star.svg';

import styles from './SidebarV2.scss';
import ChipIcon from './assets/chip.svg';

const iconsMap: Record<string, React.FC<React.SVGProps<SVGElement>>> = {
  Poker,
  Casino: ChipIcon,
  StarsRewards: StarIcon,
  Challenges: ChallengesIcon,
  Promotions: PromotionsIcon,
  Store: BrandMerchIcon,
  Languages: Language
};

interface SidebarMenuItemProps {
  icon?:
    | MainNavigationBlock['icon']
    | SecondaryNavigationBlock['icon']
    | SupportNavigationBlock['icon'];
  resolverTag?: string;
  title?: string;
  url?: string;
  onClick: () => void;
}

const SidebarItem: React.FC<SidebarMenuItemProps> = ({
  icon,
  resolverTag,
  title,
  url,
  onClick
}) => {
  const resolverLink = useResolver(resolverTag);
  const href = url || resolverLink;

  return (
    <li className={styles.sidebarItem}>
      <StarsNavigationItem
        href={href}
        className={styles.sidebarNavigationItem}
        activeClassName={styles.active}
        onClick={onClick}
      >
        {icon && <Icon icon={iconsMap[icon]} className={styles.sidebarNavigationItemIcon} />}
        {title}
      </StarsNavigationItem>
    </li>
  );
};

export default SidebarItem;
